import { useEffect } from 'react';

export function useMouseGlow() {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.addEventListener) return;

    const root = document.documentElement;
    let ticking = false;

    const onMouseMove = (e) => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          root.style.setProperty('--mouse-x', `${e.clientX}px`);
          root.style.setProperty('--mouse-y', `${e.clientY}px`);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('mousemove', onMouseMove);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, []);
}
